// extracted by mini-css-extract-plugin
export default {"main":"CountriesPage_main__IERII","menu":"CountriesPage_menu__zHGU+","workArea":"CountriesPage_workArea__o4kyr"};